'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIntl = require('react-intl');

var _reactImmutableProptypes = require('react-immutable-proptypes');

var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);

var _baseBcReactComponent = require('@bibliocommons/base-bc-react-component');

var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);

var _baseFullScreenOverlay = require('@bibliocommons/base-full-screen-overlay');

var _baseFullScreenOverlay2 = _interopRequireDefault(_baseFullScreenOverlay);

var _baseTable = require('@bibliocommons/base-table');

var _zoomableMapDisplay = require('../../zoomable-map-display');

var _zoomableMapDisplay2 = _interopRequireDefault(_zoomableMapDisplay);

require('../styles/StackMapOverlay.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var StackMapOverlay = function (_BcReactComponent) {
  _inherits(StackMapOverlay, _BcReactComponent);

  function StackMapOverlay() {
    _classCallCheck(this, StackMapOverlay);

    return _possibleConstructorReturn(this, (StackMapOverlay.__proto__ || Object.getPrototypeOf(StackMapOverlay)).apply(this, arguments));
  }

  _createClass(StackMapOverlay, [{
    key: 'renderContent',
    value: function renderContent() {
      var _this2 = this;

      if (this.props.isFetching) {
        return _react2.default.createElement(_baseTable.Placeholder, null);
      }

      if (this.props.noResults) {
        return _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'stackmap_fail' });
      }

      return _react2.default.createElement(
        'div',
        { className: 'stackmap-data' },
        this.props.maps.map(function (map) {
          return _react2.default.createElement(_zoomableMapDisplay2.default, {
            map: map,
            library: _this2.props.library,
            callno: _this2.props.callno,
            domain: _this2.props.domain,
            hideRanges: _this2.props.hideRanges,
            location: _this2.props.location });
        })
      );
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        _baseFullScreenOverlay2.default,
        { open: true, animation: 'instant', className: 'cp-stackmap-overlay', handleClose: this.props.closeStackMap },
        _react2.default.createElement(
          _reactIntl.FormattedMessage,
          { id: 'stackmap_powered_by' },
          function (message) {
            return _react2.default.createElement(
              'span',
              { className: 'powered-by-stackmap' },
              message
            );
          }
        ),
        _react2.default.createElement(
          'h3',
          null,
          _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'stackmap_general_info_heading' })
        ),
        this.renderContent()
      );
    }
  }]);

  return StackMapOverlay;
}(_baseBcReactComponent2.default);

StackMapOverlay.propTypes = {
  isFetching: _react.PropTypes.bool,
  noResults: _react.PropTypes.bool,
  maps: _reactImmutableProptypes2.default.mapContains({
    directions: _react.PropTypes.string,
    hideRanges: _react.PropTypes.bool,
    floorname: _react.PropTypes.string,
    height: _react.PropTypes.number,
    width: _react.PropTypes.number,
    ranges: _reactImmutableProptypes2.default.listOf(_reactImmutableProptypes2.default.mapContains({
      callnoDisplay: _react.PropTypes.string,
      rangename: _react.PropTypes.string
    }))
  })
};

exports.default = StackMapOverlay;


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/stackmap/lib/components/stackmap-overlay/components/StackMapOverlay.js
// module id = 1543
// module chunks = 1